import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { WebAppSharedModule } from './../../shared';
import { ItemService } from './item.service';
// import { ItemChangePasswordComponent } from './item.component';



const ENTITY_STATES = [
    // ...clientManagementRoute,
];

@NgModule({
    imports: [
        WebAppSharedModule,
         RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        // ItemChangePasswordComponent,
    ],
    entryComponents: [
        // ItemChangePasswordComponent,
    ],
    providers: [
        ItemService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class WebAppItemChangePasswordModule {}
